/** 
  All of the common routes for the frontend are added here,
  You can add a new route, customize the routes and delete the common routes here.

  You have to set the `sidebar_item: true` if you have to show the route in Sidenav.

  For adding a new route you can follow the existing routes in the routes array.
  1. The `type` key with the `collapse` value is used for a route.
  2. The `type` key with the `title` value is used for a title inside the Sidenav. 
  3. The `type` key with the `divider` value is used for a divider between Sidenav items.
  4. The `name` key is used for the name of the route on the Sidenav.
  5. The `key` key is used for the key of the route (It will help you with the key prop inside a loop).
  6. The `icon` key is used for the icon of the route on the Sidenav, you have to add a node.
  7. The `collapse` key is used for making a collapsible item on the Sidenav that has other routes
  inside (nested routes), you need to pass the nested routes inside an array as a value for the `collapse` key.
  8. The `route` key is used to store the route location which is used for the react router.
  9. The `href` key is used to store the external links location.
  10. The `title` key is only for the item with the type of `title` and its used for the title text on the Sidenav.
  10. The `component` key is used to store the component of its route.
  11. The `sidebar_item` key is used to show/hide menu in Sidenav.
  12. The `lang_attr` key is used to make it multi-lingual.
*/

// Material Dashboard 2 React layouts
import Dashboard from "layouts/dashboard";
import Controllers from "layouts/controllers";
import ActivityLog from "layouts/activity_log";
import ControllerForm from "layouts/controllers/form";
import ControllerProperties from "layouts/ControllerProperties";
import Manufacturers from "layouts/manufacturers";
import InterfaceSettings from "layouts/settings/interface_settings";

const routes = [
  {
    type: "collapse",
    name: "Dashboard",
    key: "",
    icon: "dashboard",
    route: "/",
    component: <Dashboard />,
    sidebar_item: true,
    lang_attr: "dashboard",
    permission: "any",
  },
  {
    type: "collapse",
    name: "Instruments",
    key: "instruments",
    icon: "dvr",
    sidebar_item: true,
    lang_attr: "instruments",
    permission: ["can_view_controller", "can_view_controller_properties", "can_view_manufacturers"],
    children: [
      {
        type: "collapse",
        name: "Controllers",
        key: "controllers",
        route: "/controllers",
        component: <Controllers />,
        sidebar_item: true,
        lang_attr: "controllers",
        permission: "can_view_controller",
      },
      {
        type: "collapse",
        name: "Controller Properties",
        key: "controller-properties",
        route: "/controller-properties",
        component: <ControllerProperties />,
        sidebar_item: true,
        lang_attr: "controller_properties",
        permission: "can_view_controller",
      },
      {
        type: "collapse",
        name: "Manufacturers",
        key: "manufacturers",
        icon: "factory",
        route: "/manufacturers",
        component: <Manufacturers />,
        sidebar_item: true,
        lang_attr: "manufacturers",
        permission: "can_view_manufacturers",
      },
    ],
  },
  {
    type: "collapse",
    name: "Activity Log",
    key: "activity-log",
    icon: "history",
    route: "/activity-log",
    component: <ActivityLog />,
    sidebar_item: true,
    lang_attr: "activity_log",
    permission: "can_view_activitylog",
  },
  {
    type: "collapse",
    name: "Controller",
    key: "controller",
    route: "/controller",
    component: <ControllerForm />,
    lang_attr: "controller",
    permission: "can_add_controllers",
  },
  {
    type: "collapse",
    name: "Edit Controller",
    key: "edit_controller",
    route: "/controller/:editControllerId/edit",
    component: <ControllerForm />,
    lang_attr: "edit_controller",
    permission: "can_edit_controllers",
  },
  {
    type: "collapse",
    name: "Settings",
    key: "settings",
    icon: "settings",
    permission: ["can_manage_interface_settings"],
    lang_attr: "settings",
    sidebar_item: true,
    children: [
      {
        type: "collapse",
        name: "Interface Settings",
        key: "interface-settings",
        icon: "settings",
        route: "/interface-settings",
        permission: "can_manage_interface_settings",
        lang_attr: "interface_settings",
        sidebar_item: true,
        component: <InterfaceSettings />,
      },
    ],
  },
];

export { routes };
